var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Data do cadastro:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.dataCriacao))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Número do Ofício:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.numeroOficio))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Protocolo:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.protocolo))])
            ])
          ]),
          _vm._t("baixar"),
          _c("el-row", { staticClass: "dados-doc" }, [
            _c(
              "div",
              { staticClass: "link-download" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: "cloud-download-alt" }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.downloadDoc(_vm.documento.id)
                      }
                    }
                  },
                  [_vm._v("  Baixar Documento")]
                )
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d641fce0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d641fce0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/OficioArrecadacao.vue
// module id = null
// module chunks = 